import { IsBoolean, IsNumber, IsOptional, IsString } from "class-validator"

export class AisInstitutionRequestDto {
  @IsString()
  @IsOptional()
  providerCode?: string

  @IsString()
  @IsOptional()
  country?: string

  @IsString()
  @IsOptional()
  name?: string

  @IsBoolean()
  @IsOptional()
  includeDisabled?: boolean

  @IsNumber()
  @IsOptional()
  page?: number

  @IsNumber()
  @IsOptional()
  limit?: number
}
